import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { takeUntil, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TABLE_CONFIG } from './register-epc-user-constant'
import { LoaderService } from '../shared.service';

@Component({
  selector: 'app-register-epc-users',
  templateUrl: './register-epc-users.component.html',
  styleUrls: ['./register-epc-users.component.scss']
})

export class RegisterEpcUsersComponent implements OnInit ,OnDestroy {
  private destroy$ = new Subject<void>();
  private searchSubject = new Subject<string>();
  page: any = 1;
  userCount: any = 0
  userList: any = [];
  search: any = '';
  limit: any = 20;
  offset: any = 0;
  userDeviceList: any = [];
  epcId: any;
  roleName: any
  roleColumns: any[] = [];
  tableConfig = TABLE_CONFIG;

  // navLinks: any[];
  // activeLinkIndex = 0;
  constructor(private dashbordService: DashboardService, private toastr: ToastrService, private router: Router, private modalService1: NgbModal,
    private loderService: LoaderService
  ) {
    this.epcId = localStorage.id;
    //     this.navLinks = [
    //      {
    //           label: 'Normal Users',
    //           link:  '/inject-solar/register-epc-users/normal-users',
    //           index: 0
    //       },
    //       {
    //         label: 'Wms Users',
    //         link:  '/inject-solar/register-epc-users/wms-users',
    //         index: 1
    //     },
    //     {
    //       label: 'ZE Users',
    //       link:  '/inject-solar/register-epc-users/epc-ze-users',
    //       index: 2
    //   },
    //   {
    //     label: 'DG Users',
    //     link:  '/inject-solar/register-epc-users/epc-dg-users',
    //     index: 3
    // },
    //   ];
  }

  ngOnInit() {
    this.getAllUserList(this.search, this.limit, this.offset);
    this.searchEpcUsers();
  }

  getAllUserList(search, limit, offset) {
    if (offset == 0) {
      this.page = 1;
    }

    var dataObject = {
      search: search,
      limit: limit,
      offset: offset
    }

    this.dashbordService.getAllUserList(dataObject)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async data => {
          if (data.status) {
            this.userCount = data.count;

            this.userList = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info('Login Time-out .. Please login again');
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);
              this.userList = data.resultObject;

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  nextPage(pageIndex): void {
    this.offset = (pageIndex - 1) * this.limit;
    this.getAllUserList(this.search, this.limit, this.offset);
  }

  onSearch(event: KeyboardEvent) {
    this.searchSubject.next((event.target as HTMLInputElement).value.trim());
  }
  
  searchEpcUsers() {
    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      tap(searchValue => {
        this.offset = 0;
        this.search = searchValue;
        this.getAllUserList(this.search, this.limit, this.offset);
      })
    ).subscribe();
  }

  viewDevice(viewDevices, user) {
    this.roleName = this.loderService.getRoleName(user.role);
    this.roleColumns = this.tableConfig[this.roleName] || [];
    this.userDeviceList = [];
    switch (user.role) {
      case '3':
        this.getDeviceForwmsUser(user.id);
        this.modalService1.open(viewDevices, { size: <any>'xl' });
        break;

      case '4':
        this.getDeviceForNormalUser(user.id);
        this.modalService1.open(viewDevices, { size: <any>'xl' });
        break;

      case '6':
        this.getDeviceForZEUser(user.id)
        this.modalService1.open(viewDevices, { size: <any>'xl' });
        break;

      case '7':
        this.userDeviceList = [];
        this.getDeviceForDGUser(user.id)
        this.modalService1.open(viewDevices, { size: <any>'xl' });
        break;

      default:
        console.warn("This user is not found")
    }

  }

  getDeviceForDGUser(userId) {
    var deviceObject = {
      epc_id: this.epcId,
      user_id: userId,
    }
    this.dashbordService.getEpcDgUserDevicesById(deviceObject)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async data => {
          this.userDeviceList = [];
          if (data.status) {
            this.userDeviceList = data.device_info;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  getDeviceForZEUser(userId) {

    var deviceObject = {
      epc_id: this.epcId,
      user_id: userId,
    }
    this.dashbordService.getEpcZeDeviceUserDevicesById(deviceObject)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async data => {
          this.userDeviceList = [];
          if (data.status) {

            this.userDeviceList = data.device_info;
          }

          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }

  //get devices by user id
  getDeviceForNormalUser(userId) {

    var deviceObject = {
      epc_id: this.epcId,
      user_id: userId,
    }
    this.dashbordService.getNormalUserDevicesById(deviceObject)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async data => {
          this.userDeviceList = [];
          if (data.status) {

            this.userDeviceList = data.device_info;
          }

          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }

  // get devices by user id
  getDeviceForwmsUser(userId) {
    var deviceObject = {
      epc_id: this.epcId,
      user_id: userId,
    }
    this.dashbordService.getWmsUserDevicesById(deviceObject)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async data => {
          this.userDeviceList = [];
          if (data.status) {
            this.userDeviceList = data.device_info;

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.searchSubject.next();
    this.searchSubject.complete();
  }
}
